(function(){
  const KEY = 'pv_qc_deadline';
  const DURATION_MIN = 60;

  function ensureEnd(){
    let end = localStorage.getItem(KEY);
    if (end) end = new Date(end);
    const now = new Date();
    if (!end || (end - now) <= 0) {
      end = new Date(now.getTime() + DURATION_MIN*60*1000);
      localStorage.setItem(KEY, end.toISOString());
    }
    return end;
  }

  function bind(el){
    if (!el || el.dataset.bound) return;
    el.dataset.bound = '1';
    const timerEl = el.querySelector('.qc-timer');
    if (!timerEl) return;

    // Test de velocidad 03-10-2026: el reloj se apaga solo cuando el nodo desaparece (re-render),
    // mirándolo en cada tic; antes un MutationObserver vigilaba TODA la página por cada contador.
    let id = 0;
    function tick(){
      if (!document.documentElement.contains(el)) { clearInterval(id); return; }
      const end = ensureEnd();
      const diff = Math.max(0, Math.floor((end - new Date())/1000));
      const m = Math.floor(diff/60);
      const s = diff % 60;
      timerEl.textContent = `${String(m).padStart(2,'0')} min y ${String(s).padStart(2,'0')} seg`;
    }
    tick();
    id = setInterval(tick, 1000);
  }

  // Test de velocidad 03-10-2026: `DOMContentLoaded` pasaba el EVENTO como raíz → «root.querySelector is
  // not a function» y el contador no arrancaba al cargar. Ahora acepta documento, elemento o nada.
  function boot(root){
    if (!root || typeof root.querySelector !== 'function') root = document;
    const el = (root.id === 'qc-expira') ? root : root.querySelector('#qc-expira');
    if (el) bind(el);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();

  // re-render del drawer/cart: solo se mira lo que se añade, y solo si trae el contador
  new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n=>{
    if (n.nodeType===1 && (n.id === 'qc-expira' || (n.firstElementChild && n.querySelector('#qc-expira')))) boot(n);
  }))).observe(document.documentElement,{childList:true,subtree:true});

  document.addEventListener('cart:updated', () => boot());
  document.addEventListener('drawer:open', e => boot(e.target));
})();
